'use client';

import { Component } from 'react';
import CollectionProductCard from './CollectionProductCard';

class CollectionProductCardBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  static getDerivedStateFromError() {
    return { error: true };
  }

  render() {
    if (this.state.error) return null;
    return (
      <CollectionProductCard
        item={this.props.item}
        position={this.props.position}
        size={this.props.size}
        priority={this.props.priority}
      />
    );
  }
}

export default CollectionProductCardBoundary;
